export interface IAccount {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  registered_by: string;
  added_by: IAccount | null;
  role: ERole;
  image: string;
  is_active: boolean;
  is_verified: boolean;
  created_at: string;
  updated_at: string;
}

export interface IAccountInput {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  role: string;
  password: string;
}

export interface IEditAccountInput {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  role: string;
  password?: string | null | undefined;
}

export enum ERole {
  ADMIN = "admin",
  SUPER_ADMIN = "super_admin",
  COOPERATE_ADMIN = "cooperate_admin",
  DISPATCH = "dispatch",
  CASHER = "casher",
  POLICE = "police",
  EMERGENCY_CONTACT = "emergency_contact",
}

export const AdminPrivilege: string[] = [ERole.SUPER_ADMIN, ERole.ADMIN];
export const DispatchPrivilege: string[] = [
  ERole.SUPER_ADMIN,
  ERole.ADMIN,
  ERole.DISPATCH,
];
export const DispatchWithPolicePrivilege: string[] = [
  ERole.SUPER_ADMIN,
  ERole.ADMIN,
  ERole.DISPATCH,
  ERole.POLICE,
];
export const DispatchAndSupperAdminPrivilege: string[] = [
  ERole.SUPER_ADMIN,
  ERole.DISPATCH,
];
export const FinancePrivilege: string[] = [
  ERole.SUPER_ADMIN,
  ERole.ADMIN,
  ERole.CASHER,
];
export const FinanceWithPolicePrivilege: string[] = [
  ERole.SUPER_ADMIN,
  ERole.ADMIN,
  ERole.CASHER,
  ERole.POLICE,
];
export const DispatchAndFinancePrivilege: string[] = [
  ERole.SUPER_ADMIN,
  ERole.ADMIN,
  ERole.CASHER,
  ERole.DISPATCH,
];
export const DispatchFinanceAndPolicePrivilege: string[] = [
  ERole.SUPER_ADMIN,
  ERole.ADMIN,
  ERole.CASHER,
  ERole.DISPATCH,
  ERole.POLICE,
];

export interface IAccountFinance {
  id: string;
  wallet_id: string;
  amount: number;
  admin_id: string;
  trip_id: null | string;
  type: string;
  driver: {
    id: string;
    first_name: string;
    last_name: string;
    email: null | string;
    phone: string;
    image: string;
  };
  reason: string;
  created_at: string;
  updated_at: string;
}

export interface IAccountFinanceResponse {
  data: IAccountFinance[];
  message: string;
  status: number;
  page: number;
  per_page: number;
  total: number;
  total_deduct: number;
  total_pop_up: number;
}

export interface IAccountFinanceTableData {
  loading: boolean;
  data: IAccountFinance[];
  total: number;
  page: number;
  per_page: number;
  total_deduct: number;
  total_pop_up: number;
}

export const defaultAccountFinanceTableData: IAccountFinanceTableData = {
  loading: true,
  data: [],
  page: 1,
  per_page: 10,
  total: 0,
  total_deduct: 0,
  total_pop_up: 0,
};
